import QrCodeLegenda from './QrCodeLegenda'

export default QrCodeLegenda